export const getAttendanceStats = (
  attendanceData = [],
  punchingTime
) => {
  const totalEntries = attendanceData.length;

  const totalLeave = attendanceData.filter(
    (item) => item.status !== "Present"
  ).length;

  const totalPresent =
    totalEntries - totalLeave;

  const lateLoginEmployees =
    attendanceData.filter(
      (employee) =>
        employee.login_time > punchingTime
    );

  const numberOfLateLogins =
    lateLoginEmployees.length;

  return {
    totalEntries,
    totalLeave,
    totalPresent,
    lateLoginEmployees,
    numberOfLateLogins,
  };
};